
import Vue from 'vue';
import { EventBus } from '@/plugins/eventBus';

export default Vue.extend({
  name: 'ColorPicker',
  data: () => ({
    color: 'primary',
  }),
  props: {
    model: {
      type: String,
    },
    text: {
      type: String,
      required: true,
    },
    textClass: {
      type: String,
      default: 'body-1',
    },
  },
  watch: {
    color(n: string, o: string): void {
      EventBus.$emit('colored', { model: this.model, color: n });
    },
  },
});
